import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-zoid-app-modal',
  templateUrl: './zoid-app-modal.component.html',
  styleUrls: ['./zoid-app-modal.component.scss'],
})
export class ZoidAppModalComponent {

  @Input() appContainer!: string;
}
